import { UserBasic } from 'src/app/_models/user.model';

export class Comment {
    id: number;
    content: string;
    createdAt: Date;
    idUserCreated: number;
    tableName: string;
    idTableObject: number;
    user: UserBasic = new UserBasic();
    automaticallyGenerated: boolean;
}
